import * as React from 'react';
import { Menu, Image, Sidebar } from 'semantic-ui-react';
import { HashLink } from 'react-router-hash-link';
import { menuItems } from './MenuItems';

interface Props {
    sidebarOpen?: boolean;
    activeMenu: string;
}

const SidebarMenuItem: React.SFC<any> = (props) =>
    <Menu.Item {...props} style={{ fontSize: "1em" }} >{props.children}</Menu.Item>

const MobileSidebarMenu = ({ sidebarOpen, activeMenu }: Props) =>
    <Sidebar as={Menu} animation='overlay' inverted vertical visible={sidebarOpen}
        direction="right" style={{ fontSize: "1em" }}
    >
        <SidebarMenuItem as={HashLink} to="/" style={{}}>
            <Image
                src={"/images/logo-medium-dark.png"}
                height={35}
            />
        </SidebarMenuItem>
        <SidebarMenuItem as={HashLink} to="/services" style={{}}>Services</SidebarMenuItem>
        <SidebarMenuItem>
            <Menu.Header>Company</Menu.Header>
            <Menu.Menu>
                { 
                    menuItems.company.map(i => 
                        <SidebarMenuItem key={i.label} as={HashLink} smooth to={i.url}>{i.label}</SidebarMenuItem> ) 
                }
            </Menu.Menu>
        </SidebarMenuItem>

        <SidebarMenuItem as={HashLink} to="/social" style={{}}>Social</SidebarMenuItem>

        <SidebarMenuItem>
            <Menu.Header>FAQ</Menu.Header>
            <Menu.Menu>
                { 
                    menuItems.faq.map(i => 
                        <SidebarMenuItem key={i.label} as={HashLink} smooth to={i.url}>{i.label}</SidebarMenuItem> ) 
                }
            </Menu.Menu>
        </SidebarMenuItem>

    </Sidebar>

export default MobileSidebarMenu;


// WEBPACK FOOTER //
// ./src/common/MobileSidebarMenu.tsx